import { match } from 'ts-pattern'

import type { $Enums } from '@prisma/client'

export function getReferenceFormKeyByMusicType(
  musicType: Extract<$Enums.MusicType, 'Instrumental' | 'Song' | 'Vocal'>,
) {
  return match(musicType)
    .with('Song', () => 'songReference')
    .with('Vocal', () => 'vocalReference')
    .with('Instrumental', () => 'instrumentalReference')
    .exhaustive()
}
